export type StarInfo = {
  stars: number;
  text: string;
  min: number;
  max: number;
};

// In some place, order matters. Please keep the descending order.
export const STARS = Object.freeze<
  [StarInfo, StarInfo, StarInfo, StarInfo, StarInfo, StarInfo]
>([
  { stars: 5, text: 'Excellent', min: 90, max: 100 },
  { stars: 4, text: 'Very Good', min: 75, max: 89 },
  { stars: 3, text: 'Good', min: 60, max: 74 },
  { stars: 2, text: 'Satisfactory', min: 40, max: 59 },
  { stars: 1, text: 'Fair', min: 20, max: 39 },
  { stars: 0, text: 'Beginner', min: 0, max: 19 },
]);

export enum Grade {
  U = 'U',
  E = 'E',
  D = 'D',
  C = 'C',
  B = 'B',
  A = 'A',
}

type GradeInfo = {
  grade: Grade;
  text: string;
  min: number;
  max: number;
};

// In some place, order matters. Please keep the descending order.
export const GRADES = Object.freeze<
  [GradeInfo, GradeInfo, GradeInfo, GradeInfo, GradeInfo, GradeInfo]
>([
  { grade: Grade.A, text: 'Excellent', min: 85, max: 100 },
  { grade: Grade.B, text: 'Very Good', min: 70, max: 84 },
  { grade: Grade.C, text: 'Good', min: 50, max: 69 },
  { grade: Grade.D, text: 'Satisfactory', min: 25, max: 49 },
  { grade: Grade.E, text: 'Fair', min: 1, max: 24 },
  { grade: Grade.U, text: 'Beginner', min: 0, max: 0 },
]);
